<div class="h-screen flex items-center justify-center">
  <div class="max-w-[1000px] w-1/2">
    <div class="flex items-center justify-center mb-5">
      <img
        src="../../../assets/images/company-logo.svg"
        alt="Company Logo"
        class="application-login-form__image"
      />
    </div>

    <mat-horizontal-stepper
      [selectedIndex]="getSelectedStep()"
      linear
      class="bg-transparent"
    >
      <mat-step [editable]="false">
        <ng-template matStepLabel>
          <div class="stepper-label text-white">Update Password</div>
        </ng-template>
        <!-- Step Content -->
      </mat-step>

      <mat-step [editable]="false">
        <ng-template matStepLabel>
          <div class="stepper-label text-white">Enterprise Information</div>
        </ng-template>
        <!-- Step Content -->
      </mat-step>

      <mat-step [editable]="false">
        <ng-template matStepLabel>
          <div class="stepper-label text-white">Location</div>
        </ng-template>
        <!-- Step Content -->
      </mat-step>
    </mat-horizontal-stepper>

    <div class="flex items-center justify-center">
      <!-- Onboarding View -->
      <div
        class="max-w-[500px] p-6 bg-white d-flex flex-column justify-content-center align-items-center space-y-6"
        *ngIf="!showPasswordForm && !showSuccessMessage && !showEnterpriseForm && !showLocationForm"
      >
        <div>
          <img src="../../assets/images/onboarding.svg" alt="onboarding" />
        </div>
        <p class="font-semibold text-lg">
          You are one step away {{ customerName }}!
        </p>
        <p class="text-center">
          This is your first time signing in. It's recommended to change your
          password for security purposes.
        </p>
        <button
          mat-flat-button
          color="primary"
          class="w-full"
          (click)="proceedOnboarding()"
        >
          Proceed
        </button>
      </div>

      <!-- Password Reset Form -->
      <div
        class="p-6 bg-white d-flex flex-column justify-content-center align-items-center space-y-3"
        *ngIf="showPasswordForm && !showSuccessMessage && !showEnterpriseForm"
      >
        <h2 class="text-xl font-semibold mb-2">Reset Your Password</h2>
        <form class="w-full">
          <div>
            <mat-label>Temporary Password</mat-label>
            <mat-form-field appearance="outline" class="w-full mb-2">
              <input
                matInput
                type="password"
                [(ngModel)]="temporaryPassword"
                name="temporaryPassword"
                required
              />
            </mat-form-field>
          </div>

          <div>
            <mat-label>New Password</mat-label>
            <mat-form-field appearance="outline" class="w-full mb-2">
              <input
                matInput
                type="password"
                [(ngModel)]="newPassword"
                name="newPassword"
                required
              />
            </mat-form-field>
          </div>

          <div>
            <mat-label>Confirm Password</mat-label>
            <mat-form-field appearance="outline" class="w-full mb-6">
              <input
                matInput
                type="password"
                [(ngModel)]="confirmPassword"
                name="confirmPassword"
                required
              />
            </mat-form-field>
          </div>

          <button
            mat-flat-button
            color="primary"
            (click)="resetPassword()"
            class="w-full"
          >
            Next
          </button>
        </form>
      </div>

      <!-- Success Message -->
      <div
        class="p-6 bg-white d-flex flex-column justify-content-center align-items-center space-y-3"
        *ngIf="showSuccessMessage && !showEnterpriseForm"
      >
        <img
          src="../../assets/images/password-change-successful.svg"
          alt="password-change-successful"
        />
        <h2 class="text-xl font-semibold mb-2">Password Change Successful!</h2>
        <p class="text-center">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat
        </p>
        <button
          mat-flat-button
          color="primary"
          (click)="proceedToEnterprise()"
          class="w-full"
        >
          Next
        </button>
      </div>

      <!-- Enterprise Form -->
      <div
        class="p-6 bg-white d-flex flex-column justify-content-center align-items-center space-y-2"
        *ngIf="showEnterpriseForm"
      >
        <h2 class="text-xl font-semibold mb-2">Enterprise Details</h2>
        <form class="w-full">
          <div>
            <mat-label>Enterprise Name</mat-label>
            <mat-form-field appearance="outline" class="w-full mb-2">
              <input
                matInput
                type="text"
                [(ngModel)]="enterpriseName"
                name="enterpriseName"
                required
              />
            </mat-form-field>
          </div>

          <div>
            <mat-label>Enterprise Address</mat-label>
            <mat-form-field appearance="outline" class="w-full mb-2">
              <input
                matInput
                type="text"
                [(ngModel)]="enterpriseStreet"
                name="enterpriseStreet"
                placeholder="Street"
                required
              />
            </mat-form-field>

            <div class="flex space-x-2 w-full mb-2">
              <mat-form-field appearance="outline" class="flex-1">
                <input
                  matInput
                  type="text"
                  [(ngModel)]="enterpriseCity"
                  name="enterpriseCity"
                  placeholder="City"
                  required
                />
              </mat-form-field>

              <mat-form-field appearance="outline" class="flex-1">
                <input
                  matInput
                  type="text"
                  [(ngModel)]="enterpriseState"
                  name="enterpriseState"
                  placeholder="State"
                  required
                />
              </mat-form-field>

              <mat-form-field appearance="outline" class="flex-1">
                <input
                  matInput
                  type="text"
                  [(ngModel)]="enterpriseZip"
                  name="enterpriseZip"
                  placeholder="Zip"
                  required
                />
              </mat-form-field>
            </div>
            <mat-label>Timezone</mat-label>
            <mat-form-field appearance="outline" class="w-full mb-2">
              <mat-select [(value)]="enterpriseTimezone" required>
                <mat-option
                  *ngFor="let timezone of timezones"
                  [value]="timezone.name"
                >
                  {{ timezone.name }} ({{ timezone.abbrev }})
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="w-full mb-2">
            <label for="enterpriseLogo" class="block mb-2">
              Enterprise Logo
            </label>
            <div class="form-group">
              <div
                class="logo-upload-container"
                [ngStyle]="{
                'background-color': enterpriseLogoUrl ? 'transparent' : '#e5e7eb',
                'background-image': enterpriseLogoUrl ? 'url(' + enterpriseLogoUrl + ')' : 'url(https://s3-alpha-sig.figma.com/img/4e35/3b65/47f6fe1eb7d6227268330f25f048b4a6?Expires=1734307200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=YXDd7aJkD4229dR1lnEOrAzYfV667f12tCE3MtcwR1steMLSxGgy8fRwkeqQmkshrmg8PSEt7ZCrHRVGlQwsjrAa~OkWIypmTMj~e~ovejLY5cPjNN7JyEmm2bVYiWNhFx0MN0neRvKLgfLdy5AH0ZaLYSBHgu5ujdNFHc79bDcxfjyxzsrlZIPWroUldIXSN9Sj~qIJX25MheRi6kIw7qHUcCYS23QtAPtjc0dAHr-ZcBSzOWOwM9ggb58Aq6Bttuz3NZZ43yCb1YNJ1doKVX8pKCz0vGU9Zgr3EhXiKjJBH0EOHn9O4LezOXRePJKGonuYEP1noOE6TDnJOZmIaQ__)',
                'background-size': 'cover',
                'background-position': 'center',
                'height': '200px',
                'width': '100%',
                'border-radius': '8px',
                'display': 'flex',
                'justify-content': 'center',
                'align-items': 'center',
                'position': 'relative'
              }"
              >
                <ng-container *ngIf="!uploading; else uploadingTemplate">
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="uploadButtonClick()"
                    class="upload-button"
                    type="button"
                  >
                    Upload Logo
                  </button>
                  <input
                    type="file"
                    #fileInput
                    style="display: none"
                    id="enterpriseLogo"
                    (change)="handleImageUpload($event)"
                    accept="image/png, image/jpeg"
                  />
                </ng-container>
                <ng-template #uploadingTemplate>
                  <mat-spinner></mat-spinner>
                </ng-template>
              </div>
            </div>
          </div>

          <button
            mat-flat-button
            color="primary"
            class="w-full"
            (click)="createEnterprise()"
          >
            Next
          </button>
        </form>
      </div>

      <!-- Location form -->
      <div
        class="p-6 bg-white d-flex flex-column justify-content-center align-items-center space-y-2"
        *ngIf="showLocationForm"
      >
        <div class="grid grid-cols-2 gap-4">
          <form class="w-full">
            <div>
              <mat-label>Location Name</mat-label>
              <mat-form-field appearance="outline" class="w-full mb-2">
                <input
                  matInput
                  type="text"
                  [(ngModel)]="locationName"
                  name="locationName"
                  required
                />
              </mat-form-field>
            </div>

            <div>
              <mat-label>Location Address</mat-label>
              <mat-form-field appearance="outline" class="w-full mb-2">
                <input
                  matInput
                  type="text"
                  [(ngModel)]="locationStreet"
                  name="locationStreet"
                  placeholder="Street"
                  required
                />
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-full mb-2">
                <input
                  matInput
                  type="text"
                  [(ngModel)]="locationCity"
                  name="locationCity"
                  placeholder="City"
                  required
                />
              </mat-form-field>

              <div class="flex space-x-2 w-full mb-2">
                <mat-form-field appearance="outline" class="flex-1">
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="locationState"
                    name="locationState"
                    placeholder="State"
                    required
                  />
                </mat-form-field>

                <mat-form-field appearance="outline" class="flex-1">
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="locationZip"
                    name="locationZip"
                    placeholder="Zip"
                    required
                  />
                </mat-form-field>
              </div>

              <mat-label>Timezone</mat-label>
              <mat-form-field appearance="outline" class="w-full mb-2">
                <mat-select [(value)]="locationTimezone" required>
                  <mat-option
                    *ngFor="let timezone of timezones"
                    [value]="timezone.name"
                  >
                    {{ timezone.name }} {{ timezone.abbrev }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </form>
          <div class="h-full w-full border rounded-md px-2 py-2">
            <mat-form-field class="w-full">
              <mat-label>Search Locations</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="searchLocation"
                name="searchLocation"
                placeholder="Enter location name"
                class="w-full"
              />
            </mat-form-field>

            <div class="w-full">
              <div
                *ngFor="let location of filteredLocations()"
                class="flex justify-between items-center border-b py-2"
              >
                <span>{{ location.name }}</span>
                <button
                  mat-icon-button
                  color="warn"
                  (click)="deleteLocation(location)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

              <!-- No Results Message -->
              <div
                *ngIf="filteredLocations().length === 0"
                class="text-center text-gray-500"
              >
                No locations found.
              </div>
            </div>
          </div>
        </div>
        <button
          mat-flat-button
          style="
            width: 100%;
            border: 1px solid #2c679f;
            color: #2c679f;
            border-radius: 6px;
          "
          (click)="createLocation()"
        >
          Save Location
        </button>
        <div class="w-full flex space-x-4">
          <button
            mat-flat-button
            color="secondary"
            class="w-full"
            (click)="goToEnterprise()"
          >
            Previous
          </button>
          <button
            mat-flat-button
            color="primary"
            class="w-full"
            (click)="completeOnboarding()"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
